import React from 'react';
import dateFormat from 'dateformat';
import VoiceInput from './VoiceInput';

const FormatDate = (dateToFormat) => {
    var pattern = /(\d{1,2})-(\d{1,2})-(\d{4})/;
    if (pattern.test(dateToFormat)) {
        var dt = new Date(dateToFormat.replace(pattern,'$3-$2-$1'));
        return dateFormat(dt, "mmm d, yyyy")
    }
    return "Unknown";
}

// props: radios, component, first
export const DoctorInput = (props) => {
    var i = 0;
    const currentRadio = props.component.state[`${props.component.state.step}-radioButton`];
    const currentComment = props.component.state[`${props.component.state.step}-comment`] ?? "";

    return (
        <div>
            <div className="ci-card">
                <div className="ci-card-label">Observations</div>
                <div className="ci-radio-group">
                    {props.radios.map(function(row) {
                        i++;
                        return (
                            <label key={i} className="ci-radio-option">
                                <input
                                    type="radio"
                                    name="radioButton"
                                    value={row}
                                    checked={currentRadio === row}
                                    onChange={(e) => onInput(e, props)}
                                />
                                <span>{row}</span>
                            </label>
                        );
                    })}
                </div>
            </div>
            <div className="ci-card">
                <div className="ci-field">
                    <label>Comment</label>
                    <div className="ci-field-with-voice">
                        <textarea
                            name="comment"
                            rows={4}
                            placeholder="Add a comment..."
                            value={currentComment}
                            onChange={(e) => onInput(e, props)}
                        />
                        <VoiceInput language="en" onTranscript={(text) => {
                            const key = `${props.component.state.step}-comment`;
                            const existing = props.component.state[key] || "";
                            props.component.setState({ [key]: existing + (existing ? " " : "") + text });
                        }} />
                    </div>
                </div>
            </div>
            <div className="tn-nav-buttons">
                {!props.first && (
                    <a href="." className="homeButton" onClick={(e) => getPrev(e, props)}>
                        ← Back
                    </a>
                )}
                <a href="." className="logSubmit" style={{ width: 'auto', marginTop: 0 }} onClick={(e) => getNext(e, props)}>
                    Next →
                </a>
            </div>
        </div>
    );
}

const getNext = (e, props) => {
    e.preventDefault()
    props.component.setState({"step": props.component.state.step+1}, props.component.getRes)    
}

const getPrev = (e, props) => {
    e.preventDefault()
    props.component.setState({"step": props.component.state.step-1}, props.component.getRes)
}

const onInput = (e, props) => {
    props.component.setState({[`${props.component.state.step}-${e.target.name}`]:e.target.value})
}

export const RecordHistory = (props) => {
    var i = 0;
    var j = 0;
    if (!props.table || props.table.length === 0) {
        return <div className="ci-card" style={{ marginBottom: '14px' }}><p className="normalText">No history data available.</p></div>;
    }
    return (
        <div className="ci-card" style={{ marginBottom: '14px' }}>
            <div className="ci-card-label">History</div>
            <div className="profile-table-wrap">
                <table className="table-compact-alter">
                    <thead>
                        <tr>
                            <th>Date</th>
                            {props.tableType.map(function(title) {
                                j++;
                                return <th key={j}>{title}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {props.table.map(function(row) {
                            i++;
                            return (
                                <tr key={i}>
                                    <td>{FormatDate(row.date)}</td>
                                    {makeDataRows(props, row)}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
const makeDataRows = (props, row) => {
    let final = []
    let end = props.tableType.length
    if(row === [] || end+1 !== Object.keys(row).length) {
        return <td>&nbsp;</td>
    }
    for(let i = 1; i <= end; i++) {
        if(row["value"+i] === undefined) {
            end++   
        }
        else {
            final.push(
                <td className="tableText" key={i}>{row["value"+i]}</td>
            )
        }

        //just in case
        if(end >= 10000) {
            break;
        }
    }
    return final;
}

export const HistoryData = (props) => {
    const labSections = [
        { id: 1, label: "Blood Pressure" },
        { id: 2, label: "Volume Assessment" },
        { id: 3, label: "Dialysis Adequacy" },
        { id: 4, label: "Access Assessment" },
        { id: 5, label: "Anemia Management" },
        { id: 6, label: "Bone Mineral Mgmt" },
        { id: 7, label: "Nutrition Assessment" },
    ];

    let mainBody;
    if (props.question === "confirm") {
        mainBody = (
            <div className="lab-main">
                <div className="lab-confirm">
                    <div className="lab-confirm-icon">✓</div>
                    <h3>Data Recorded</h3>
                    <p>Select another section from the menu to enter more data, or <a href="/patients/lookup">return to patient list</a>.</p>
                </div>
            </div>
        );
    } else {
        mainBody = (
            <div className="lab-main">
                <h2 className="lab-main-title">{props.res.name}</h2>
                <div className="lab-fields">
                    {getRecords(props.res.questions, props.component)}
                </div>
                <div className="ci-submit-row" style={{ marginTop: '24px' }}>
                    <a href="./confirm" className="logSubmit ci-submit-btn" onClick={props.component.handleSubmit}>
                        Save
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className="lab-layout">
            <nav className="lab-sidebar">
                <div className="lab-sidebar-title">Lab Sections</div>
                {labSections.map((s) => (
                    <a key={s.id} href={`./${s.id}`} className="lab-sidebar-link">
                        {s.label}
                    </a>
                ))}
            </nav>
            {mainBody}
        </div>
    );
}

const getRecords = (items, component) => {
    let i = 0;
    return items.map(row => {
        i++;
        return (
            <div className="ci-field" key={i} style={{ marginBottom: '12px' }}>
                <label htmlFor={`lab-field-${i}`}>{row.question}</label>
                <input
                    type="text"
                    id={`lab-field-${i}`}
                    name={row.question}
                    onChange={(e) => component.handleChange(e, row.questionID, component, i)}
                    placeholder={row.question}
                />
            </div>
        );
    });
}